module.exports = __webpack_public_path__ + "img/2.8bf85079.jpg";